import { Reveal, SectionHead } from "./Reveal";
import { WHY_US } from "@/data/content";
import { BadgeCheck, Clock3, FileText, Landmark, GitBranch, FolderCheck, BellRing } from "lucide-react";

const ICONS = [BadgeCheck, Clock3, FileText, Landmark, GitBranch, FolderCheck, BellRing];

const WhyUs = () => (
    <section id="why-us" className="py-24 sm:py-32 border-t border-white/10 bg-[#0D1730]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="Why Pramukh"
                title="Why Choose Pramukh Compliance Services"
                sub="A professional compliance partner — not merely a registration agent."
            />
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="why-us-grid">
                {WHY_US.map((w, i) => {
                    const Icon = ICONS[i];
                    return (
                        <Reveal key={w.title} delay={(i % 3) * 0.08}>
                            <div className="h-full border border-white/10 bg-[#0A1128] p-7 hover:border-sky-400/40 transition-colors duration-300">
                                <span className="w-11 h-11 rounded-lg bg-blue-600/20 border border-blue-500/30 flex items-center justify-center">
                                    <Icon size={19} className="text-sky-400" />
                                </span>
                                <h3 className="mt-5 font-heading text-base font-semibold text-white">{w.title}</h3>
                                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{w.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
                <Reveal delay={0.16}>
                    <div className="h-full border border-sky-400/30 bg-gradient-to-br from-blue-700/30 to-transparent p-7 flex flex-col justify-between">
                        <p className="font-heading text-lg font-semibold text-white leading-snug">
                            Registrations • Compliance • Registers • Due Dates • Documentation • Government Support
                        </p>
                        <a href="#contact" data-testid="why-us-cta" className="mt-6 text-sm font-semibold text-sky-300 hover:text-sky-200 transition-colors">
                            Contact Pramukh Compliance Services →
                        </a>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default WhyUs;
